import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { TableRow } from '@material-ui/core'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../../context/DailyMonitoringDetailsFiltersContext'
import EmptyCells from '../../../../../../components/EmptyCells'
import DefaultTableCellSmallSpace from '../../../../../../components/DefaultTableCellSmallSpace'
import { GET_ORDERS_QUANTITY_HISTORY } from '../../../../../../queries/dailyMonitoringCancelled'
import { formatNumber, getDaysInMonth, DaysInMonth } from '../../../../../../utils/Helpers'
import { defaultFormatMonthTimeZone } from '../../../../../../utils/consts'

const title = 'QTD de pedidos'
export default function DailyOrdersQuantity (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDERS_QUANTITY_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const createdAt: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <EmptyCells title={title} />
  if (loading || !data) return <EmptyCells title={title} />
  if (error) return <EmptyCells title={title} />
  if (!data.ordersAggs?.aggregations?.salesOverTime) return <EmptyCells title={title} />

  const { buckets } = data.ordersAggs?.aggregations?.salesOverTime
  return (
    <TableRow>
      <DefaultTableCellSmallSpace style={{ fontSize: 12 }}>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = buckets.filter((b: any) => moment.parseZone(String(b.key_as_string)).isSame(moment(day.date, 'DD/MMM/YYYY'), 'day'))[0]
        return !isEmpty(bucket) ? <DefaultTableCellSmallSpace style={{ fontSize: 12 }} key={`${bucket.key_as_string}-${bucket.quantity.value}`}>{formatNumber(bucket.quantity.value, 0)}</DefaultTableCellSmallSpace> : <DefaultTableCellSmallSpace>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
